// ==============================================

//        NAV FUNCTIONS

// ==============================================

document.addEventListener('DOMContentLoaded', function (e) {


    //        Show / Hide responsive nav
    // ==============================================
    
    let btnSearch     = document.getElementById('btn-search');
    let btnBurger     = document.getElementById('btn-burger');
    let btnBurgerIcon = document.getElementById('btn-burger__icon');
    let header        = document.getElementById('header');
    let navWrapper    = document.getElementById('nav-wrapper');
    
    // open / close reponsive menu
    function toggleNavResponsive(e) {
        e.preventDefault();
        document.body.classList.toggle('no-scroll');
        btnBurgerIcon.classList.toggle('is-active');
        navWrapper.classList.toggle('is-open');
        navWrapper.classList.add('has-transition');
    }

    btnBurger.addEventListener('click', toggleNavResponsive);


    // close responsive menu if still open on large screens
    function checkNavResponsive() {
        // CSS Media Query width == window.innerWidth including scrollbars (NOT document.documentElement.clientWidth)
        if(window.innerWidth >= 1250) closeNavResponsive();
    }

    window.addEventListener('resize', checkNavResponsive);


    // reset button states (remove nav transition when switch to resolution)
    function closeNavResponsive(transition=false) {
        document.body.classList.remove('no-scroll');
        btnBurgerIcon.classList.remove('is-active');
        navWrapper.classList.remove('is-open');
        if (!transition) navWrapper.classList.remove('has-transition');
    }


    //        Blue header when scroll
    // ==============================================

    let lastScroll = 0;

    function toggleSolidHeader() {
        let currentScroll = document.body.scrollTop || document.documentElement.scrollTop;

        // scroll down -> hide  / scroll up -> show
        (currentScroll > 200) ? header.classList.add('is-solid') : header.classList.remove('is-solid');
        lastScroll = currentScroll;
    }

    window.addEventListener('scroll', toggleSolidHeader);
    window.addEventListener('resize', toggleSolidHeader);
    toggleSolidHeader();
    


    //        Scroll to anchor
    // ==============================================

    // Smooth scroll to anchor
    function scrollToAnchor(hash, offset=0, delay=0) {
        offset -= header.offsetHeight;
        let target  = document.getElementById(hash);
        let targetY = target.offsetTop + offset;

        // calculate scroll speed according to the distance between current position and target
        let scrolled    = window.pageYOffset;
        let scrollDelta = Math.abs(target.offsetTop - scrolled);
        let scrollSpeed = Math.floor(scrollDelta / 1.2);
            scrollSpeed = Math.min(Math.max(scrollSpeed, 800), 1600);
        // console.log('target.offsetTop / scrolled', target.offsetTop, scrolled, scrollDelta, '->', scrollSpeed);

        $('body,html').delay(delay).animate({ scrollTop : targetY }, scrollSpeed, 'easeInOutCubic', function(){  });
    }
    
    // btn arrow in home page slider --> scroll to next block after slider
    if (document.getElementById('btn-further')) {
        document.getElementById('btn-further').addEventListener('click', function(e) {
            e.preventDefault();
            scrollToAnchor(this.hash.substr(1));
        });
    }


    // hash link in primary nav in front page --> scroll to #id anchor
    document.querySelectorAll('.nav-primary__link').forEach( function( el ) {
        if (el.hash && el.getAttribute('href').substr(0,1) == '#') {
            el.addEventListener('click', function(e) {
                e.preventDefault();
                // close nav mobile first if open
                if(navWrapper.classList.contains('is-open')) {
                    scrollToAnchor(this.hash.substr(1), 0, 250 );   
                    closeNavResponsive(true);
                } else {
                    scrollToAnchor(this.hash.substr(1));   
                }    
            });
        }
    });


    // If hash value in home page url ( index.php#metier ) --> scroll to #id anchor
    let hash = location.hash.substr(1);
    if (hash) {
        location.hash = '';
        setTimeout(function(){
            scrollToAnchor(hash);
        }, 800);
    }



    //        Open / Close language switcher dropdown
    // ==============================================
    let langSwitcher = document.getElementById('lang-switcher');
    let langSwitcherBtn = document.getElementById('lang-switcher__btn');

    function openLangDropdown(e) {
        e.preventDefault();
        langSwitcher.classList.add('is-open');
        // langSwitcherBtn.classList.add('is-open');
        langSwitcherBtn.removeEventListener('click', openLangDropdown);
        langSwitcherBtn.addEventListener('click', closeLangDropdown);
        document.addEventListener('click', clickOutsideLangDropdown);
    }

    function closeLangDropdown(e) {
        e.preventDefault();
        langSwitcher.classList.remove('is-open');
        langSwitcherBtn.removeEventListener('click', closeLangDropdown);
        langSwitcherBtn.addEventListener('click', openLangDropdown);
        document.removeEventListener('click', clickOutsideLangDropdown);
    }

    langSwitcherBtn.addEventListener('click', openLangDropdown);


    function clickOutsideLangDropdown(e) {
        if (!langSwitcher.contains(e.target)) {
            closeLangDropdown(e);
        }
    }

    //        AOS animation
    // ==============================================

    // !!! hack : delay to init AOS after Slick init
    setTimeout(function(){
        AOS.init({
            duration: 600,
            once: true,
            // easing: 'linear',
            easing: 'ease-out-quart',
            disable: false,
        });
        }, 1000
    );
    
    btnSearch.addEventListener('click', (e) => {
        var expanded = btnSearch.getAttribute('aria-expanded') === 'true';
        
        if(!expanded) btnSearch.setAttribute('aria-expanded', true);
        else btnSearch.setAttribute('aria-expanded', false);
    })

})
